export default "__VITE_ASSET__B1P2CSvI__"